import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { InputSharedModule } from '../../molecules/input/input.module';
import { InputCalendarSharedComponent } from './input.calendar.component';
import { FaIconSharedModule } from './../../atoms/fa.icon/fa.icon.module';
import { DatepickerSharedModule } from '../../molecules/datepicker/datepicker.module';

@NgModule({
    declarations: [
        InputCalendarSharedComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        InputSharedModule,
        FaIconSharedModule,
        DatepickerSharedModule
    ],
    exports: [
        InputCalendarSharedComponent
    ]
})

export class InputCalendarSharedModule {}
